var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-server-side-table',_vm._g({ref:"lineTable",staticClass:"practices-table",attrs:{"fetch-data":_vm.$api.admin.practice.fetch,"columns":_vm.columns,"enable-search":"","paginate":""},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }